<div>
<nx-pageTitle-box
  [label]="user?.firstName + ' ' + user?.lastName"
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'/settings'"
  [bcRootLvl1Label]="'Nutzer'"
  [bcRootLvl1Path]="'/settings/users'"
  [icon]="'icon-person'"
  [iconToolTip]="'Nutzer'">
  <ng-template nxTemplate="tag">
    <p-tag
      [value]="user?.enabled ? 'aktiv' : 'inaktiv'"
      [severity]="user?.enabled ? 'success' : 'danger'">
    </p-tag>
  </ng-template>
  <ng-template nxTemplate="end">
    <nx-default-button
      *ngIf="user?.enabled"
      (click)="suspendUser()"
      [tooltip]="'Nutzer deaktivieren'"
      [label]="'Nutzer deaktivieren'"
      [style]="'light'">
    </nx-default-button>
    <nx-default-button
      *ngIf="!user?.enabled"
      (click)="enableUser()"
      [tooltip]="'Nutzer aktivieren'"
      [label]="'Nutzer aktivieren'"
      [style]="'light'">
    </nx-default-button>
    <nx-default-button
      class="ml-2"
      (click)="resetPassword()"
      [tooltip]="'Passwort zurücksetzen'"
      [label]="'Passwort zurücksetzen'"
      [style]="'light'">
    </nx-default-button>
  </ng-template>
</nx-pageTitle-box>


  <p-tabView [scrollable]="true">
    <p-tabPanel header="Allgemein">
      <div class="flex flex-row gap-4 mt-2">
      <div
        class="basis-1/2">
        <nx-headline-box
          [label]="'Nutzerdaten'">
          <ng-template nxTemplate="end">
            <nx-default-button
              (click)="editUser()"
              [tooltip]="'Nutzer bearbeiten'"
              [icon]="'icon-edit'"
              [style]="'light'">
            </nx-default-button>
          </ng-template>
        </nx-headline-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Vorname'">
          {{user?.firstName}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Nachname'">
          {{user?.lastName}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Kürzel'">
          {{user?.initials}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'E-Mail'">
          {{user?.email}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Niederlassungen'">
          {{ getUserLocations() }}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Gruppen'">
        {{ userGroups | join }}
      </nx-default-box>
      </div>
      <div
        class="basis-1/2">
        <nx-headline-box
          [label]="'Lizenz'">
          <ng-template nxTemplate="end">
            <nx-default-button
              (click)="editLicence()"
              [tooltip]="'Lizenz bearbeiten'"
              [icon]="'icon-edit'"
              [style]="'light'">
            </nx-default-button>
          </ng-template>
        </nx-headline-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Lizenztyp'">
          {{user?.licenceType?.name}}
        </nx-default-box>
      </div>
    </div>
    </p-tabPanel>
    <p-tabPanel header="Rollen">

      <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
        <div class="flex-1 flex flex-row items-center ml-3 font-medium">
          Rollenliste
        </div>
        <div class="flex-none flex flex-row justify-center items-center">
          <div *ngIf="!selectedRoles || selectedRoles?.length === 0"
            class="bg-white text-base pt-[0.25rem] pb-[0.188rem] px-[0.313rem] opacity-50 rounded-md">
            Keine ausgewählt
          </div>
          <div *ngIf="selectedRoles?.length > 0"
            class="bg-white text-base pt-[0.25rem] pb-[0.188rem] px-[0.313rem] rounded-md">
            {{selectedRoles?.length}} ausgewählt
          </div>
          <nx-default-button
            [tooltip]="'Rollen entfernen'"
            [disabled]="!selectedRoles || selectedRoles?.length === 0"
            (click)="removeRoles()"
            [style]="'light'"
            [label]="'entfernen'"
            class="ml-2">
          </nx-default-button>
        </div>
        <div class="flex-1 flex flex-row justify-end items-center">
          <input
          pInputText
          type="text"
          (input)="roleTable.filterGlobal($event.target?.['value'], 'contains')"
          class="p-inputtext p-component p-element mr-3"
        placeholder="Rolle suchen" />
        <nx-default-button
          [style]="'light'"
          class="mr-2"
          (click)="addRoles()"
          [label]="'Rollen hinzufügen'"
          [icon]="'icon-plus'">
        </nx-default-button>
        </div>
      </div>


      <p-table
        #roleTable
        [value]="usersRolesFiltered"
        [scrollable]="true"
        [paginator]="true"
        [(selection)]="selectedRoles"
        [rows]="15"
        [rowsPerPageOptions]="[15, 20, 50]"
        [totalRecords]="usersRolesFiltered?.length"
        [showCurrentPageReport]="true"
        [filterDelay]="200"
        [rowSelectable]="isRowSelectableFunction"
        currentPageReportTemplate="{first} - {last} von {totalRecords}"
        [globalFilterFields]="['label']"
        [resizableColumns]="true">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>Name</th>
            <th>Vererbt von</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-role>
          <tr>
            <td>
              <p-tableCheckbox [value]="role" [disabled]="role.isInherited" ></p-tableCheckbox>
            </td>
            <td>{{role.label}}</td>
            <td>{{role.inheritedFrom ? (role.inheritedFrom | join) : "-"}}</td>
            <td class="text-right">
              <nx-default-button
                [disabled]="role.isInherited"
                [tooltip]="'Rolle entfernen'"
                [style]="'dark'"
                (click)="role.isInherited ? null : removeRole(role)"
                [label]="'entfernen'">
              </nx-default-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="2" class="emptyMessage">Keine Rollen gefunden.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

  </p-tabView>

